import {
  GET_OBJECTS,
  GET_OBJECT
} from '../constants/ActionTypes'

const initialState = {
  objects: [],
};

const reducer = (state = initialState, action) => {
  const currentState = Object.assign({}, state, action);

  switch (action.type) {
    case GET_OBJECTS:
      return Object.assign(currentState, { objects: [] });
    case GET_OBJECT:
      return Object.assign(currentState, { object: {} });
    default:
      return currentState;
  }
}

export default reducer